import { BrowserStorage } from './browserStorage';

export const workWithLocalStorage = new BrowserStorage(localStorage);
